export const isThisBrowserAvailable = () => {

  // Opera 8.0+
  const isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/false || !!document.documentMode;

  if(navigator.userAgent.indexOf('Edge') >= 0){
    return true
  }else if (isIE || isOpera) {
    return false
  }else {
    return true;
  }

}



export const isThisScreenSizeAvailable = () => {
  return window.screen.width < 1280;
}

